import { IconSize } from "../enums/ButtonEnum";

export const getIconSizeClass = iconSize => {
  switch (iconSize) {
    case IconSize.SMALL:
      return "icon-size-small";
    case IconSize.MEDIUM:
      return "icon-size-medium";
    case IconSize.LARGE:
      return "icon-size-large";
    case IconSize.XLARGE:
      return "icon-size-xlarge";
    case IconSize.XXLARGE:
      return "icon-size-xxlarge";
    case IconSize.XXXLARGE:
      return "icon-size-xxxlarge";
    case IconSize.XXXXLARGE:
      return "icon-size-xxxxlarge";
    case IconSize.DEFAULT:
    default:
      return "icon-size-default";
  }
};
